/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesHu = {
  privacy: {
    pageTitle: "Adatvédelmi irányelvek",
    lastUpdated: "Utolsó frissítés: 2026. június 1.",
    introduction: {
      title: "Bevezetés",
      body: "A WasOK egy helyi elsőbbségű bevásárlási segédalkalmazás, amely abban segít a felhasználóknak, hogy emlékezzenek a korábban megvásárolt, értékelt vagy véleményezett termékekre.\n\nEz az Adatvédelmi irányelv elmagyarázza, milyen információkat dolgozunk fel az alkalmazás használata során, hogyan tároljuk az adatokat, és hogyan működhetnek bizonyos harmadik fél szolgáltatásai.",
    },
    dataStored: {
      title: "Az alkalmazás által tárolt adatok",
      body: "A WasOK a következő információkat helyben tárolja az eszközén:\n\n• beolvasott termékvonalkódok\n• a felhasználó által megadott terméknevek és részletek\n• értékelések és megjegyzések\n• bevásárlólisták\n• termékkategóriák\n• árak és üzletinformációk\n• termék- és üzletfotók\n\nA termékadatait és fotóit nem töltjük fel a WasOK szervereire.",
    },
    permissions: {
      title: "Használt engedélyek",
      camera: {
        title: "Kamera",
        body: "A kameraelérést a következőkhez használjuk:\n\n• vonalkód beolvasása\n• termékfotók készítése",
      },
      photos: {
        title: "Fotók és média",
        body: "A fotó- vagy galériaelérést csak akkor használjuk, ha:\n\n• képeket csatol termékekhez\n• fotókat tartalmazó biztonsági mentéseket állít vissza",
      },
      files: {
        title: "Fájl- és tárhelyelérés",
        body: "A fájlelérés a következőkre használható:\n\n• biztonsági mentési fájlok exportálása\n• a felhasználó által kiválasztott biztonsági mentések importálása\n• bevásárlólisták vagy biztonsági mentések megosztása",
      },
    },
    backup: {
      title: "Biztonsági mentés és exportálás",
      body: "A WasOK lehetővé teszi biztonsági mentési fájlok létrehozását az alkalmazásadatokról és opcionális fotókról.\n\nA biztonsági mentési fájlok helyben jönnek létre az eszközén, és a felhasználó által választott szolgáltatásokkal tárolhatók vagy megoszthatók, például:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• helyi eszköztárhely\n\nA WasOK nem tölti fel a biztonsági mentéseket a saját szervereire.",
      onlineProductLookup: {
        title: "Online termékkeresés",
        body: "Ha a Beállításokban engedélyezi az online vonalkód-keresést, a WasOK csak a beolvasott vonalkódszámot küldheti el nyilvános termékadatbázisoknak (például az Open Food Facts-nek), hogy terméknevet és márkát javasoljon. A WasOK ehhez a funkcióhoz nem tölti fel az értékeléseit, megjegyzéseit, fotóit, bevásárlólistáit, kategóriáit, üzletinformációit vagy biztonsági mentési adatait. Ezt bármikor kikapcsolhatja a Beállításokban.",
      },
    },
    advertising: {
      title: "Hirdetések és harmadik fél szolgáltatásai",
      intro:
        "A WasOK kiválasztott harmadik fél szolgáltatásokat használ bizonyos funkciók biztosításához.",
      admob: {
        title: "Google AdMob",
        body: "A Google AdMob-ot az alkalmazáson belüli hirdetések megjelenítésére használjuk.\n\nA Google és partnerei olyan információkat dolgozhatnak fel, mint:\n\n• hirdetési azonosítók\n• eszközinformációk\n• IP-cím\n• diagnosztikai és használati információk\n\nBizonyos régiókban a felhasználóktól hozzájárulást kérhetnek a személyre szabott hirdetések megjelenítése előtt.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "A WasOK a Firebase Crashlytics-et használja az összeomlások azonosításához és az alkalmazás stabilitásának javításához.\n\nAz összeomlási jelentések olyan technikai információkat tartalmazhatnak, mint:\n\n• eszközmodell\n• operációs rendszer verziója\n• alkalmazásverzió\n• összeomlási diagnosztika\n\nAz összeomlási jelentések szándékosan nem tartalmazzák a termékértékeléseit, jegyzeteit, bevásárlólistáit vagy fotóit.",
      },
      externalProductDatabases: {
        title: "Külső termékadatbázisok",
        body: "A vonalkód-keresési funkció külső termékadatbázisokat használhat a termékinformációk lekéréséhez.\n\nTovábbi információért tekintse meg az adott szolgáltatók adatvédelmi irányelveit.",
      },
    },
    dataSecurity: {
      title: "Adatbiztonság",
      body: "A WasOK az alkalmazásadatokat helyben tárolja az eszközén, az operációs rendszer által biztosított tárolási mechanizmusokkal.\n\nBár ésszerű intézkedéseket teszünk a helyi alkalmazásadatok védelmére, egyetlen elektronikus tárolási módszer sem teljesen biztonságos.\n\nA felhasználók felelősek a fontos adatok biztonsági mentésének fenntartásáért, ha kívánják.",
    },
    children: {
      title: "Gyermekek adatvédelme",
      body: "A WasOK nem 13 év alatti gyermekeknek szól.",
    },
    notifications: {
      title: "Értesítések",
      body: "A WasOK opcionálisan helyi értesítéseket hozhat létre az eszközén, hogy emlékeztesse a termékek értékelésére a vásárlás után.\n\nEzek az értesítések helyben jönnek létre és ütemeződnek az eszközén, és nem igényelnek fiókot vagy távoli szervert.\n\nAz értesítéseket bármikor kikapcsolhatja az eszközbeállításokban vagy az alkalmazásban, ha támogatott.",
    },
    yourControl: {
      title: "Az adatai feletti ellenőrzés",
      body: "Ön:\n\n• bármikor szerkesztheti vagy törölheti a tárolt termékeket\n• törölheti az alkalmazásadatokat az eszközéről\n• eltávolíthatja az alkalmazást\n• exportálhatja adatainak biztonsági mentéseit",
    },
    changes: {
      title: "Az irányelv módosításai",
      body: "Ez az Adatvédelmi irányelv időről időre frissülhet.\n\nA módosítások a frissített verzió közzétételekor lépnek hatályba.",
    },
    contact: {
      title: "Kapcsolat",
      body: "Ha kérdése van ezzel az Adatvédelmi irányelvvel kapcsolatban, lépjen kapcsolatba:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Szolgáltatási feltételek",
    lastUpdated: "Utolsó frissítés: 2026. június 1.",
    acceptance: {
      title: "A feltételek elfogadása",
      body: "A WasOK letöltésével, telepítésével vagy használatával elfogadja ezeket a Szolgáltatási feltételeket.\n\nHa nem ért egyet ezekkel a Feltételekkel, ne használja az alkalmazást.",
    },
    license: {
      title: "Licenc",
      body: "A WasOK korlátozott, nem kizárólagos, nem átruházható, visszavonható licencet biztosít Önnek az alkalmazás használatára e Feltételeknek megfelelően.",
    },
    acceptableUse: {
      title: "Elfogadható használat",
      body: "Ön vállalja, hogy nem:\n\n• él vissza az alkalmazással\n• zavarja az alkalmazás működését\n• kísérel meg reverse engineeringet vagy módosítást\n• használja az alkalmazást a hatályos törvények vagy előírások megsértésével",
    },
    localData: {
      title: "Helyi adatok és biztonsági mentések",
      body: "A WasOK a felhasználói adatokat helyben tárolja az eszközön.\n\nA felhasználók felelősek a fontos adatok biztonsági mentésének fenntartásáért, ha kívánják.\n\nBár biztonsági mentési és visszaállítási funkció biztosítható, a WasOK nem garantálja a tárolt adatok elvesztése, sérülése vagy meghibásodása ellen.",
    },
    advertisements: {
      title: "Hirdetések",
      body: "Az alkalmazás harmadik fél hirdetési partnerei — köztük a Google AdMob — által biztosított hirdetéseket jeleníthet meg.",
    },
    noWarranty: {
      title: "Jótállás kizárása",
      body: "A WasOK „ahogy van” és „ahogy elérhető” alapon kerül biztosításra, bármilyen kifejezett vagy hallgatólagos jótállás nélkül.\n\nNem garantáljuk, hogy:\n\n• az alkalmazás mindig elérhető lesz\n• az alkalmazás hibamentes lesz\n• soha nem következik be adatvesztés\n• minden funkció megszakítás nélkül működik minden eszközön",
    },
    limitationLiability: {
      title: "Felelősségkorlátozás",
      body: "A törvény által megengedett maximális mértékben a WasOK és fejlesztői nem felelősek a következőkért:\n\n• adatvesztés\n• nyereségkiesés\n• eszközproblémák\n• közvetett vagy következményes károk\n• az alkalmazás használatából vagy használhatatlanságából eredő megszakítások",
    },
    thirdParty: {
      title: "Harmadik fél szolgáltatásai",
      body: "Bizonyos funkciók vagy tartalmak harmadik fél szolgáltatásaira támaszkodhatnak, beleértve a hirdetésszolgáltatókat és a felhasználó által választott külső tárolási/megosztási szolgáltatásokat.\n\nA WasOK nem felelős a harmadik fél szolgáltatásaiért vagy azok irányelveiért.",
    },
    productInformation: {
      title: "Termékinformációk",
      body: "Bizonyos termékadatok harmadik fél vonalkód-kereső szolgáltatásaiból származhatnak.\n\nA WasOK nem garantálja a külső adatforrások által szolgáltatott információk pontosságát, teljességét, elérhetőségét vagy alkalmasságát.\n\nA felhasználóknak szükség esetén önállóan ellenőrizniük kell a termékinformációkat.",
    },
    changesApp: {
      title: "Az alkalmazás módosításai",
      body: "A WasOK bármikor, előzetes értesítés nélkül módosítható, frissíthető, felfüggeszthető vagy megszüntethető.",
    },
    changesTerms: {
      title: "Ezen feltételek módosításai",
      body: "Ezek a Feltételek időszakonként frissülhetnek.\n\nAz alkalmazás további használata a frissítések hatálybalépése után a módosított Feltételek elfogadását jelenti.",
    },
    contact: {
      title: "Kapcsolat",
      body: "Ezekkel a Feltételekkel kapcsolatos kérdések esetén lépjen kapcsolatba:\n\nsupport@wasok.app",
    },
  },
};
